import { t } from 'i18next'

import { ResidentAppError } from '../../../../common/error'
import { ContractTerminationDestination } from '../../../../common/types'

export const useTerminationDestinationToLabel = () => {
  const terminationDestinationToLabel = (
    destination: ContractTerminationDestination | ''
  ): string => {
    switch (destination) {
      case ContractTerminationDestination.BUYING_PROPERTY:
        return t('terminateContract:terminationDestinations.buyingProperty')
      case ContractTerminationDestination.MOVE_TO_ANOTHER_APARTMENT_OF_SAME_OWNER:
        return t(
          'terminateContract:terminationDestinations.moveToAnotherApartmentOfSameOwner'
        )
      case ContractTerminationDestination.MOVE_TO_ANOTHER_RENTAL:
        return t(
          'terminateContract:terminationDestinations.moveToAnotherRental'
        )
      case ContractTerminationDestination.MOVE_TO_RIGHT_OF_OCCUPANCY_OF_SAME_OWNER:
        return t(
          'terminateContract:terminationDestinations.moveToRightOfOccupancyOfSameOwner'
        )
      case ContractTerminationDestination.MOVE_TO_RIGHT_OF_OCCUPANCY_OF_ANOTHER_OPERATOR:
        return t(
          'terminateContract:terminationDestinations.moveToRightOfOccupancyOfAnotherOperator'
        )
      case ContractTerminationDestination.MOVE_TO_RIGHT_OF_OCCUPANCY:
        return t(
          'terminateContract:terminationDestinations.moveToRightOfOccupancy'
        )
      case ContractTerminationDestination.MOVE_TO_CARE_HOME_OR_HOSPITAL:
        return t(
          'terminateContract:terminationDestinations.moveToCareHomeOrHospital'
        )
      case ContractTerminationDestination.OTHER:
        return t('terminateContract:terminationDestinations.other')
      case ContractTerminationDestination.UNKNOWN:
        return t('terminateContract:terminationDestinations.unknown')
      case '':
        return ''
      default:
        throw ResidentAppError.ClientError('UNKNOWN', {
          message: `Unknown termination destination: ${destination}`,
        })
    }
  }

  return { terminationDestinationToLabel }
}
